var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconoMenuMobil = function SvgIconoMenuMobil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    fill: "none",
    viewBox: "0 0 28 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M15.333 7H2a1.333 1.333 0 0 0 0 2.667h13.333a1.333 1.333 0 0 0 0-2.667ZM26 .333H2A1.333 1.333 0 0 0 2 3h24a1.333 1.333 0 1 0 0-2.667Z"
  })));
};
export default SvgIconoMenuMobil;